<template>
  <div>
    <top-nav :page_title="page_title"></top-nav>
    <br>
    <!-- Card -->
    <div class="card card-cascade">
      <mdb-card class="md-card-profile">
        <mdb-card-body class="mx-4 mt-4">

          <!-- Profile Card -->
          <div class="card-group">
            <div class="card card-cascade wider">
              <!-- Avatar -->
              <div class="avatar mx-auto white">
                <img :src=cardUserImage
                     alt="Your Picture"
                     class="rounded-circle">
              </div>

              <!-- Card content -->
              <div class="card-body card-body-cascade text-center pb-0">

                <!-- NAME -->
                <h4 class="card-title"><strong><em>Name:</em> {{ user.fullname }}</strong></h4>
                <!-- ROLE -->
                <h5 class="blue-text pb-2"><strong><em>Role:</em> {{ user.role }}</strong></h5>
                <!-- CONTACT DETAILS -->
                <p class="card-text"><em>Contact Info: </em> {{ user.email }} </p>

                <hr>
                <mdb-col class="d-flex justify-content-end">
                  <router-link to="/edit-user">
                    <div class="text-center">
                      <button @click="requestUpdateUser"
                              class="btn btn-outline-info btn-rounded"
                              type="button"> Update Details<i class="fas fa-pencil-alt"></i></button>
                    </div>
                  </router-link>

                  <!--  DELETE USER    -->
                  <delete-user :user="user"></delete-user>
                </mdb-col>
              </div>
            </div>
          </div>

          <br><br>
          <!-- Activity Card-->
          <div class="card mb-4">
            <!-- FLASH MESSAGES -->
            <FlashMessage :position="'right bottom'"></FlashMessage>

            <!-- Title -->
            <div class="header pt-3 blue-gradient">
              <mdb-row class="d-flex justify-content-center">
                <h3 class="white-text mb-3 pt-3"><i class="far fa-list-alt"></i> Your Activity</h3>
              </mdb-row>
            </div>

            <!-- Card content -->
            <div class="card-body">
              <lab-admin-dashboard v-if="isLabAdmin()"></lab-admin-dashboard>
              <research-scientist-dashboard v-if="isResearcher()"></research-scientist-dashboard>
              <theme-admin-dashboard v-if="isThemeAdmin()"></theme-admin-dashboard>
              <student-dashboard v-if="isStudent()"></student-dashboard>
              <system-admin-dashboard v-if="isAdmin()"></system-admin-dashboard>
            </div>
            <!-- Card content -->
          </div>
          <!-- Activity Card -->
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>
</template>
<script>
import {mdbCard, mdbCardBody, mdbCol, mdbRow} from "mdbvue";
import TopNav from "@/components/TopNav";
import axios from "axios";
import {user_resource} from "@/utils/api_paths";
import {
  handleError, isAdmin, isLabAdmin, isResearcher, isStudent, isThemeAdmin, redirectAfterCountDown,
  secureStoreGetAuthString, setUserDashboardInfo, startLoader,
} from "@/utils/util_functions";
import {font_scale} from '@/utils/constants';
import EventBus from '@/components/EventBus';
import LabAdminDashboard from "@/pages/UserProfile/UserDashboards/LabAdminDashboard";
import ResearchScientistDashboard from "@/pages/UserProfile/UserDashboards/ResearchScientistDashboard";
import ThemeAdminDashboard from "@/pages/UserProfile/UserDashboards/ThemeAdminDashboard";
import StudentDashboard from "@/pages/UserProfile/UserDashboards/StudentDashboard";
import SystemAdminDashboard from "@/pages/UserProfile/UserDashboards/SystemAdminDashboard";
import DeleteUser from "@/components/in_form/DeleteUserComponent";

export default {
  name: "UserCard",
  props: {
    cardUserImage: {
      type: String,
      default: require("../../assets/user_avatar.png")
    }
  },
  data() {
    return {
      page_title: "Dashboard",
      user: {},
      font_scale,
    };
  },
  methods: {
    isLabAdmin, isResearcher, isThemeAdmin, isStudent, isAdmin,
    getUserDetails() {
      let loader = startLoader(this)

      axios.get(user_resource, {
        headers:
            {
              Authorization: secureStoreGetAuthString()
              // email: email,
            }
      }).then((res) => {
            setTimeout(() => {
              loader.hide()
              this.user = res.data.message;
              // set a shared variable with user data for children to copy from.
              setUserDashboardInfo(this.user)
              // emit event to notify attached children to fetch the user data they require
              EventBus.$emit('created-user-dashboard')
            }, 2500)
          })
          .catch((error) => { handleError(this, error, loader)});
    },

    requestUpdateUser() {
      let loader = startLoader(this)

      setTimeout(() => {
        loader.hide()
        redirectAfterCountDown(this, '/edit-user')
      }, 1000)
    },
  },

  created() {
    this.getUserDetails()
  },
  components: {
    DeleteUser, SystemAdminDashboard, StudentDashboard,
    ThemeAdminDashboard, ResearchScientistDashboard, LabAdminDashboard, mdbCard, mdbCardBody, mdbRow, mdbCol, TopNav}
};
</script>
